<script>
import Layout from '@layouts/main'
import LayoutMember from '@layouts/LayoutMember'
import { merchantComputed } from '@state/helpers'
import formatDate from '@utils/format-date'

export default {
  page() {
    return {
      title: this.$t('global.MEMBER_PREPAID'/* 預付方案 */),
    }
  },
  components: { Layout, LayoutMember },
  filters: {
    formatDate,
  },
  props: {
    orders: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      filterStatus: {
        name: 'status',
        list: [
          {
            text: '所有狀態',
            value: ''
          },
          {
            text: '已付款',
            value: '1'
          },
          {
            text: '已取消',
            value: '0'
          },
          {
            text: '未付款',
            value: '2'
          },
        ],
        value: ''
      },
    }
  },
  computed: {
    ...merchantComputed
  },
  methods: {
    handleCancel(order) {
      const vnodes = [];

      if (order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {order.merchant.email}
      </a>
      )
      }

      if (order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(
        messageElement,
        this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_TITLE',
          {
            actionName: this.$t(
              `product.prepaid.ORDER_CANCEL`
            ),
            merchantName: order.merchant.name,
          } /* 取消預訂請聯繫{merchantName} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    handleContact(order) {
      const vnodes = []

      if (order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {order.merchant.email}
      </a>
      )
      }

      if (order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(messageElement, this.$t('global.CONTACT_PREFIX', { name: order.merchant.name }/* 聯繫{name} */), {
        distinguishCancelAndClose: false,
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
        ),
        confirmButtonClass: 'button is-primary is-rounded',
      })
    },
    handleChangeFilter(value, name) {
      this.$router.push({
        query: {
          ...this.$route.query,
          p: 1,
          [name]: value
        }
      })
    },
    orderStatusText(orderStatus) {
      const status = [
        this.$t('global.CANCELED' /* 已取消 */),
        this.$t('global.PAID' /* 已付款 */),
        this.$t('global.UNPAID' /* 未付款 */),
      ];
      return status[orderStatus]
    },
    orderStatusClass(orderStatus) {
      const statusClassMap = {
        0: 'is-orange',
        1: 'is-primary',
        2: 'is-danger',
      };
      return statusClassMap[orderStatus]
    },
    orderStatusAlias(orderStatus) {
      const statusAliasMap = [
        'cancel',
        'paid',
        'unpaid',
      ];

      return statusAliasMap[orderStatus]
    },
  },
}
</script>
<template>
  <Layout>
    <LayoutMember>
      <div class="booking-section">
        <div class="level subsection is-auto-style">
          <h4
            class="level-left booking-section__title"
          >
            {{ $t('global.PREPAID'/*預付方案*/) }}
          </h4>
          <div class="level-right">
            <div class="buttons is-filter-style">
              <BaseFilter
                v-model="filterStatus.value"
                :name="filterStatus.name"
                icon="filter"
                :select="filterStatus.list"
                @change="handleChangeFilter"
              />
            </div>
          </div>
        </div>
        <div v-if="orders.length > 0" class="subsection product-wrapper">
          <div
            v-for="(prepaidOrderItem, index) in orders"
            :key="index"
            :class="$style.wrapper"
            class="has-block-link"
          >
            <router-link
              class="is-block-link"
              :to="{
                name: 'member-prepaid-item',
                params: {
                  orderKey: prepaidOrderItem.id,
                },
                query: {
                  merchant: $route.query.merchant,
                  language: $route.query.language,
                },
              }"
            ></router-link>
            <div :class="$style.inner">
              <div class="columns is-vcentered is-multiline is-mobile">
                <div class="column is-full-mobile is-two-fifths-tablet">
                  <div>
                    <div style="margin-bottom: 0.5rem">
                      <div class="level is-size-medium">
                        <div class="level-left">
                          <b-tag :type="orderStatusClass(prepaidOrderItem.status)" rounded style="margin-right: 0.5rem">
                            {{orderStatusText(prepaidOrderItem.status) }}
                          </b-tag>
                          {{prepaidOrderItem.prepaidTitle}}
                        </div>
                      </div>
                    </div>
                    <p class="has-text-grey-light is-text-content">
                      {{ prepaidOrderItem.merchant.name }}
                    </p>
                  </div>
                </div>
                <div class="column is-half-mobile">
                  <span class="is-size-6">${{prepaidOrderItem.total}}</span>
                </div>
                <div class="column is-half-mobile is-narrow-tablet">
                  <div>
                    <span  class="has-text-grey-light">{{ $t('global.ORDER_CREATED'/*訂單成立時間*/) }}</span>
                    <br>{{prepaidOrderItem.created | formatDate}}
                  </div>
                </div>
                <div class="column is-full-mobile is-narrow-tablet">
                  <div>
                    <div class="buttons is-right">
                      <router-link
                        class="button is-outlined is-rounded fix-width-167 is-primary"
                        :to="{
                          name: 'member-prepaid-applicable',
                          params: {
                            orderKey: prepaidOrderItem.id,
                          },
                          query: {
                            merchant: $route.query.merchant,
                            language: $route.query.language,
                          },
                        }"
                      >
                        {{ $t('global.MEMBER_ORDER_VIEW_APPLICABLE'/*查看適用項目*/) }}
                      </router-link>
                      <span v-if="orderStatusAlias(prepaidOrderItem.status) === 'unpaid'" @click.stop.prevent="''">
                    <b-dropdown aria-role="list" position="is-bottom-left">
                      <b-button
                        slot="trigger"
                        type="is-primary is-circle is-outlined"
                      >
                        <BaseIcon name="ellipsis-h" />
                      </b-button>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'member-prepaid-item',
                            params: {
                              orderKey: prepaidOrderItem.id,
                            },
                            query: {
                              merchant: $route.query.merchant,
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看訂單詳情*/) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'booking-prepaid-unpaid-checkout',
                            params: {
                              merchantAlias: prepaidOrderItem.merchant.alias,
                              prepaidId: prepaidOrderItem.prepaidAlias,
                              orderKey: prepaidOrderItem.id,
                            },
                            query: {
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'booking-prepaid-item',
                            params: {
                              merchantAlias: prepaidOrderItem.merchant.alias,
                              prepaidAlias: prepaidOrderItem.prepaidAlias,
                            },
                            query: {
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t(`product.prepaid.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="handleContact(prepaidOrderItem)"
                      >
                        {{ $t('global.CONTACT_MERCHANT'/*聯絡商家*/) }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="handleCancel(prepaidOrderItem)"
                      >
                        {{ $t(`product.prepaid.ORDER_CANCEL`/* 取消預訂 */) }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                      <span v-if="orderStatusAlias(prepaidOrderItem.status) === 'paid'" @click.stop.prevent="''">
                    <b-dropdown aria-role="list" position="is-bottom-left">
                      <b-button
                        slot="trigger"
                        type="is-primary is-circle is-outlined"
                      >
                        <BaseIcon name="ellipsis-h" />
                      </b-button>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'member-prepaid-item',
                            params: {
                              orderKey: prepaidOrderItem.id,
                            },
                            query: {
                              merchant: $route.query.merchant,
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看訂單詳情*/) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'booking-prepaid-item',
                            params: {
                              merchantAlias: prepaidOrderItem.merchant.alias,
                              prepaidAlias: prepaidOrderItem.prepaidAlias,
                            },
                            query: {
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t('global.BUY_AGAIN'/*再次購買*/) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="handleContact(prepaidOrderItem)"
                      >
                        {{ $t('global.CONTACT_MERCHANT'/*聯絡商家*/) }}
                      </b-dropdown-item>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="handleCancel(prepaidOrderItem)"
                      >
                        {{ $t(`product.prepaid.ORDER_CANCEL`/* 取消預訂 */) }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                      <span v-if="orderStatusAlias(prepaidOrderItem.status) === 'cancel'" @click.stop.prevent="''">
                    <b-dropdown aria-role="list" position="is-bottom-left">
                      <b-button
                        slot="trigger"
                        type="is-primary is-circle is-outlined"
                      >
                        <BaseIcon name="ellipsis-h" />
                      </b-button>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'member-prepaid-item',
                            params: {
                              orderKey: prepaidOrderItem.id,
                            },
                            query: {
                              merchant: $route.query.merchant,
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看訂單詳情*/) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        has-link
                        aria-role="listitem"
                      >
                        <router-link
                          :to="{
                            name: 'booking-prepaid-item',
                            params: {
                              merchantAlias: prepaidOrderItem.merchant.alias,
                              prepaidAlias: prepaidOrderItem.prepaidAlias,
                            },
                            query: {
                              language: $route.query.language,
                            },
                          }"
                        >{{ $t(`product.prepaid.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}</router-link>
                      </b-dropdown-item>
                      <b-dropdown-item
                        aria-role="listitem"
                        @click="handleContact(prepaidOrderItem)"
                      >
                        {{ $t('global.CONTACT_MERCHANT'/*聯絡商家*/) }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="subsection">
          {{ $t('global.MEMBER_ORDER_NULL'/*沒有任何訂單或沒有符合搜尋條件的訂單*/) }}
        </div>
      </div>
      <BasePagination v-if="orders.length > 0" :pagination="pagination"/>
    </LayoutMember>
  </Layout>
</template>
<style lang="scss" module>
  .wrapper {
    cursor: pointer;
    &:hover {
      transition: box-shadow .3s;
      box-shadow: 0 0 15px 0 rgba(178,180,181,.3);
    }
    &:not(:last-child) {
      .inner {
        border-bottom: 1px solid $color-border-base;
      }
    }
    .inner {
      padding: 1.5rem 0;
      margin: 0 1.5rem;
    }
  }
</style>
